<template>
    <div>
        <el-form  :model="formData" ref="formRef" label-width="90px" size="mini" inline>
            <el-form-item  prop="i_gsid" :label="$t('form_company')" >{{formData.vc_gsname}}</el-form-item>
            <el-form-item  prop="f_pay" label="金额">{{formData.f_amountleft}}</el-form-item>
            <el-form-item  prop="f_pay" label="币种">{{formData.vc_bzname}}</el-form-item>
            <el-form-item  prop="f_pay" label="类型">{{formData.vc_type}}</el-form-item>
            <el-table
                    class="mrt10"
                    ref="table"
                    size="mini"
                    :height="tableHeight"
                    border
                    :data="tableData"
                    :highlight-current-row="true"
                    style="width: 100%;margin-right: 9px;margin-left: 9px">
<!--                <el-table-column   align="center" type="selection" width="50px"></el-table-column>-->
                <el-table-column align="center" label="客户名称" prop="i_khid"    show-overflow-tooltip>
                    <template  slot-scope="scope">
                        <el-select   @change="changekh(scope.row,scope.$index)" class="marr4" v-model="scope.row.i_khid" size="mini" clearable remote :remote-method="remoteMethodkh" filterable placeholder="请选择客户">

<!--                        <el-select   class="marr4" v-model="scope.row.i_khid" size="small" clearable filterable placeholder="请选择客户">-->
                            <el-option v-for="item in khList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                            </el-option>
                        </el-select>

                    </template>
                </el-table-column>
<!--                <el-table-column align="center" label="币种" prop="vc_bzname"  width="120"   show-overflow-tooltip>-->
<!--                    <template  slot-scope="scope">-->
<!--                            <el-select      class="marr4" @change="changeData($event,index)" v-model="scope.row.i_bzid" size="small"  filterable placeholder="请选择币种">-->
<!--                                <el-option-->
<!--                                        v-for="item in bzList"-->
<!--                                        :key="item.i_id"-->
<!--                                        :label="item.vc_name"-->
<!--                                        :value="item.i_id">-->
<!--                                </el-option>-->
<!--                            </el-select>-->
<!--                    </template>-->
<!--                </el-table-column>-->
                <el-table-column align="center" label="汇率"  prop="f_rate" width="120"    show-overflow-tooltip>
                    <template  slot-scope="scope">
                        <el-input-number  class="changeinput" :controls="false"  size="mini" v-model="scope.row.f_rate" ></el-input-number>

                    </template>
                </el-table-column>
                <el-table-column align="center" label="金额" prop="f_amount" width="120"   show-overflow-tooltip>
                    <template  slot-scope="scope">
                        <el-input-number  class="changeinput" :controls="false" :precision="2" size="mini" v-model="scope.row.f_amount" ></el-input-number>

                    </template>
                </el-table-column>
                <el-table-column  width="50" label="操作" align="center">
                    <template slot="header" slot-scope="scope" >
                        <el-button  icon="el-icon-plus"  @click="addRow"   size="mini"  type="text" ></el-button>
                    </template>
                    <template slot-scope="scope" >
                        <div style="text-align: center !important;">
                            <el-button  icon="el-icon-minus"  type="text" @click="deleteRow(scope.row,scope.$index)"  size="mini" class="mrl10" ></el-button>

                        </div>
                    </template>
                </el-table-column>
<!--                <el-table-column align="center" label="备注" prop="vc_note"    show-overflow-tooltip>-->

<!--                </el-table-column>-->
            </el-table>

            <div class="formDiv flex jcsb">
                <el-form-item class="form-title" prop="vc_lruname" label="录入人" >
                    <span>{{formData.vc_lruname}}</span>
                </el-form-item>
                <el-form-item class="form-title" prop="dt_createtime" label="录入日期" >
                    <span>{{formData.dt_createtime}}</span>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <template >
                <el-button type="primary" @click="saveForm" :disabled="disabled" :class="baseerp+'btn'" size="small" >保存</el-button>
<!--                <el-button type="primary" @click="editForm" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="!canEdit">编辑</el-button>-->
            </template>

            <el-button @click="cancel" size="small">取 消</el-button>

        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";

    export default {
        name: "DetailPage",
        components: {},
        props:{
            data:{
                type:Object,
                required:true
            }
        },
        data() {
            return {
                pickerOptions: {
                    disabledDate(time) {
                        let curDate=(new Date()),perM;
                        if(curDate.getMonth()>0){
                            perM=(new Date(curDate.getFullYear(),curDate.getMonth()-1,1)).getTime();
                        }else{
                            perM=(new Date(curDate.getFullYear()-1,11,1)).getTime();
                        }
                        let today=(new Date()).getDate();
                        let same=today*24*3600*1000;
                        // let sameMonth=curDate-same;//当月月初
                        let sameMonth=perM;
                        return time.getTime() > Date.now() || time.getTime() < sameMonth;
                        // const times = new Date(new Date().toLocaleDateString()).getTime() - 15 * 8.64e7 - 1;
                        // return time.getTime() > Date.now() || time.getTime() < times; // 如果Date.now() - 8.64e7没有后面的-8.64e7就是可以选择今天的

                    }
                },
                baseerp:'',
                canEdit:false,
                formData:{
                    i_gsid:'',
                    vc_bank_account:'',
                    i_khid:'',
                    i_sktype:3,
                    i_bzid:1,
                    vc_bzname:'人民币',
                    f_rate:1,
                    f_amount:'12345',
                    dt_paytime:'',
                    i_isbankcharges:0,
                    vc_note:'',
                },
                gsList:[],
                yhzhList:[],
                khList:[],
                gysList:[],
                dhcdList:[{i_id:2,vc_name:'承兑'},{i_id:3,vc_name:'电汇'}],
                tableHeight:0,
                searchkh:'',
                bzList:[],
                disabled:false,
                tableData:[{vc_khname:'', f_amount:0, f_rate:1, i_khid:null}],
            }
        },

        watch: {
            data: {
                handler() {
                    if (this.data) {
                        this.i_id=this.data.i_id;
                        // console.log(this.i_id,'this.i_id',this.data,'this.data')
                        this.formData=JSON.parse(JSON.stringify(this.data));
                        this.canEdit=false;
                        this.formData.i_id=this.i_id;
                        this.formData.i_ykhid=this.data.i_khid;
                        this.formData.vc_ykhname=this.data.vc_khname;
                        this.formData.f_amountleft=this.data.f_remainAmount;
                        this.formData.dt_paytime=this.getDateYYYYMMddHHMMSS();
                        // this.formData.dt_paytime='2025-01-02';
                        this.formData.dt_createtime=this.getDateYYYYMMddHHMMSS();
                        this.formData.vc_lruname=sessionStorage.getItem("lruname");
                        this.formData.i_lruid=sessionStorage.getItem("userid");
                        // console.log(this.fo,'foemate')
                    }
                },
                immediate: true,
                deep: true
            },
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            // this.getDictForAmountDivide();
            // this.getCompanyList();
            this.getbzlist();
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-(n.h)*0.3-145;
                if(this.tableHeight<60)this.tableHeight=60;
            },
            // editForm(){
            //     this.canEdit=true
            // },
            addRow(){
                this.tableData.push({
                    vc_khname:'',
                    f_amount:0,
                    f_rate:this.formData.f_rate,
                    i_khid:null,
                });
                this.$forceUpdate();

            },
            deleteRow(row,i){
                this.tableData.splice(i,1)
            },
            saveForm(){
                this.saveAmountDivided()
                this.disabled=true
            },
            cancel(){
                this.$emit('close')
            },
            remoteMethodkh(val){
                this.searchkh=val
                this.getDictForAmountDivide()
            },
            async getDictForAmountDivide(){
                let param={
                    vc_khname: this.searchkh,
                };
                let res=await API.getDictForAmountDivide(param);
                if ( res.code == 1 ){
                    this.khList=res.data
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            changekh(e,i){
                if(this.tableData[i].i_khid) {
                    let gsobj=this.khList.find(gs => gs.i_id == this.tableData[i].i_khid)
                    this.tableData[i].vc_khname = gsobj.vc_name;
                }
            },
            changeData(e,i) {
                //console.log(e,type)
                    this.formData.i_bzid = e;
                    let choo = this.bzList.filter(item => {
                        return item.i_id == e
                    });
                    if (choo.length > 0) {
                        this.tableData[i].vc_bzname = choo[0].vc_name;
                        this.tableData[i].f_rate = choo[0].f_rate;
                    } else {
                        this.tableData[i].vc_bzname = '';
                        this.tableData[i].f_rate = 0;
                    }
                    this.$forceUpdate();
            },
            async getbzlist(){
                let param={

                };
                let res=await API.getbzlist(param);
                if ( res.code == 1 ){
                    this.bzList=res.data.list;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

            async saveAmountDivided(){
                let f=this.formData;
                f.dividedList=this.tableData;
                let param=f;
                let res=await API.saveAmountDivided(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.$emit('close','save');
                    this.disabled=false

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false

                }
            },


            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                return `${date.getFullYear()}-${month}-${strDate}`

            },
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display:flex;
    }
    .jcsb{
        justify-content: space-between;

    }
</style>